<template>
    <div class="docs-list demo" id="section-5" style="display: none">
        <h1>Introduction to Yunzi App</h1>

        <hr/>

        <p>“Yunzi” App is a mobile application that provides developer first-hand experience on Yunzi’s sensory
            functionality. iPhone version is available to download. You may access to the project source code on our
            GitHub.
        </p>
        <pre><code>“Yunzi” App, developed on the basis of SBK (Sensoro Beacon Kit), requires to run and compile with Xcode 6 and iOS 8 SDK. It is compatible with iOS 7.0 mobile operating system or above.
</code></pre>

        <p><strong>Main functions:</strong></p>

        <h3>I. Device list and search</h3>

        <p>The list indicates the SN and ID of circumjacent Yunzi, which are accordant with the ones on Yunzi’s printed
            stickers. You may also find the designated Yunzi through search function.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/1.png" alt=""/></p>

        <h3>II. System privilege validation</h3>

        <p>Since Yunzi is a smart sensor built on iBeacon technology, it will require corresponding system privileges
            including location based services and authorization for the mobile bluetooth.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/0.png" alt=""/></p>

        <h3>III. Functions and features of Yunzi</h3>

        <p>“Yunzi” App’s main functions include:</p>

        <pre><code>(1) RSSI (signal intensity), distance，proximity based on iBeacon;
(2) Sensors: temperature, light sensors and accelerometer;
(3) Practical use scenarios and functions achieved with Yunzi: distance and proximity detection,  light, temperature and motion sensing, push notifications, etc.
</code></pre>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/2.png" alt=""/></p>

        <h5>1.Distance</h5>

        <p>The App will indicate the distance between Yunzi and the user if their relative position has altered.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/3.png" alt=""/>
            <img src="/static/image/developer/yunzi/4.png" alt=""/></p>

        <h5>2.Proximity</h5>

        <p>For proximity levels are defined to describe the distance between Yunzi and a user - immediate, near, far and
            unknown. The app will indicate user’s relative location when his/her distance to certain Yunzi has been
            changed.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/5.png" alt=""/>
            <img src="/static/image/developer/yunzi/6.png" alt=""/>
            <img src="/static/image/developer/yunzi/7.png" alt=""/></p>

        <h5>3.Light</h5>

        <p>Switched on Yunzi’s light sensor, the color of the circular indicator will change according to the ambient
            light condition.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/8.png" alt=""/>
            <img src="/static/image/developer/yunzi/9.png" alt=""/>
            <img src="/static/image/developer/yunzi/10.png" alt=""/></p>

        <h5>4.Temperature</h5>

        <p>With the temperature sensor on, the temperature of Yunzi’s chip leads to the color change of the page
            background.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/11.png" alt=""/>
            <img src="/static/image/developer/yunzi/12.png" alt=""/></p>

        <h5>5.Move</h5>

        <p>When the accelerometer is enabled, Yunzi’s movement will trigger the animation that the earth icon starts to
            rotate; as the counter adds 1 when the movement is ended.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/13.png" alt=""/></p>

        <h5>6.Push notifications</h5>

        <p>The presence and disappearance of a smart device at Yunzi’s signal coverage area is capable to waken the
            “Yunzi" App according to the sensor’s feedbacks. “Yunzi" App will judge whether a push notification should
            be generated or not according to the sensor configurations.</p>

        <p style="text-align:center"><img src="/static/image/developer/yunzi/14.png" alt=""/>
            <img src="/static/image/developer/yunzi/15.png" alt=""/>
            <img src="/static/image/developer/yunzi/16.png" alt=""/>
        </p>
        <div class="download-app source first">
            <a href="https://github.com/sensoro/Yunzi-iOS">
                iOS Source Code
            </a>
            <a href="https://github.com/Sensoro/SDK-Android/tree/master/Samples/Yunzi-Android">
                Android Source Code</a>
        </div>
        <!--.download-app
        a.ios-download(href="itms-services://?action=download-manifest&amp;url=https%3A%2F%2Fstatic.sensoro.com%2Fdownloads%2Fapps%2Fsensoro-yunzi-demo%2Fios%2Fsensoro-yunzi.plist") iOS App
        a.android-download(href="http://static.sensoro.com/downloads/apps/sensoro-yunzi-demo/android/sensoro-yunzi-demo.apk") Android App
        -->
        <div class="download-app">
            <span style="display: block; margin-bottom: 10px;">Download more Apps</span>
            <img id="qrcode" src="/static/image/docs/qrcode.png" width="80px"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "yunzi"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/demo.vue